import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// TODO: Header wird nicht sauber ein-/ausgefadet. Ursache bei Veränderung von sticky/static vermutet. Toleranzbereich einbauen.
class Header {
	constructor() {
		this.initialized = false;
		this.stickyClass = 'tht-sticky-active';
		this.animationDuration = 0.4;
		this.headerElement = null;
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.headerElement = document.querySelector('#brx-header');

		if (this.headerElement) {
			this.setupHeaderTransition();
		}

		this.initialized = true;
	}

	setupHeaderTransition() {
		const introElement = document.querySelector('.tht-intro-full');
		if (!introElement) {
			return;
		}

		// Check if intro is already out of view on page load
		const introRect = introElement.getBoundingClientRect();
		const isIntroOutOfView = introRect.bottom < 0;

		if (isIntroOutOfView) {
			this.headerElement.classList.add(this.stickyClass);
		}

		const enterTimeline = gsap
			.timeline({ paused: true })
			.set(this.headerElement, { autoAlpha: 0 })
			.call(() => this.headerElement.classList.add(this.stickyClass))
			.to(this.headerElement, {
				autoAlpha: 1,
				duration: this.animationDuration,
			});

		const enterBackTimeline = gsap
			.timeline({ paused: true })
			.to(this.headerElement, {
				autoAlpha: 0,
				duration: this.animationDuration,
			})
			.call(() => this.headerElement.classList.remove(this.stickyClass))
			.to(this.headerElement, { autoAlpha: 1, duration: 0.1 });

		ScrollTrigger.create({
			trigger: introElement,
			start: 'bottom top',
			end: 'bottom top',
			onEnter: () => {
				if (!this.headerElement.classList.contains(this.stickyClass)) {
					enterTimeline.restart();
				}
			},
			onEnterBack: () => {
				if (this.headerElement.classList.contains(this.stickyClass)) {
					enterBackTimeline.restart();
				}
			},
		});
	}
}

export const header = new Header();
